module.exports = __webpack_public_path__ + "img/leona_street_blätter_ocular.960ad515.jpg";